import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionBoardComponent } from './component/question-board/question-board.component';
import { QuestionTypeMenuComponent } from './component/question-type-menu/question-type-menu.component';
import { StepsMenuComponent } from './component/steps-menu/steps-menu.component';
import { QuestionnaireStore } from '../../store/questionnaire-store';
import { debounceTime, filter, map, startWith, tap, withLatestFrom } from 'rxjs';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { Step } from 'src/app/models/step.model';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { EStatus } from 'src/app/models/EnumStatus';
import { Router } from '@angular/router';
import { Question } from 'src/app/models/question.model';
import { SaveComponent } from './component/save/save.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionBoardEditComponent } from './component/question-board-edit/question-board-edit.component';
import { CdkDropListGroup } from '@angular/cdk/drag-drop';
import { CreateHeaderComponent } from './component/create-header/create-header.component';
import { CollectionQuestionsComponent } from './component/collection-questions/collection-questions.component';
import { DragStore } from 'src/app/store/drag-store';
import domToImage from 'dom-to-image';
import { SvgIconComponent } from 'angular-svg-icon';
import { LoadingBoardComponent } from './component/loading-board/loading-board';
import { EQuestionnaireStatus } from 'src/app/models/questionnaireGrid.model';
import { GlobalService } from 'src/app/shared/services/global-service';
import { GlobalStore } from 'src/app/store/global-store';
import { TostPositionEnum, TostTypeEnum } from 'src/app/shared/models/tostes.model';
import { TostesStore } from 'src/app/store/tostes-store';
import { QuestionnairesGridStore } from '../questionnaires/store/questionnairesGrid-store';
import { CollectionQuestionApiService } from '../collections/services/collection-question-api.service';
import { SaveNameListComponent } from './component/question-form/components/save-name-list/save-name-list.component';
import { MatDialog } from '@angular/material/dialog';
import { OptionsList } from 'src/app/models/optionsList.model';
import { UuidService } from 'src/app/services/uuid.service';
import { BoardHeaderComponent } from './component/board-header/board-header.component';
import { AnswersStore } from 'src/app/store/answers-store';



@Component({
    selector: 'que-create-questionnaire-page',
    imports: [CommonModule, QuestionBoardComponent, QuestionBoardEditComponent, StepsMenuComponent, TranslateDirective, TranslatePipe, QuestionTypeMenuComponent,
        FormsModule, ReactiveFormsModule, SaveComponent, CdkDropListGroup, CreateHeaderComponent, CollectionQuestionsComponent, SvgIconComponent, LoadingBoardComponent, BoardHeaderComponent],
    templateUrl: './create-questionnaire-page.component.html',
    styleUrls: ['./create-questionnaire-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateQuestionnairePageComponent implements OnInit {
  @ViewChild('warpBoard', { static: true }) warpBoard!: ElementRef;
  #questionnaireStore = inject(QuestionnaireStore);
  #questionnaireApiService = inject(QuestionnaireApiService);
  #questionnarieGridStore = inject(QuestionnairesGridStore);

  definitionsSig$ = toSignal(this.#questionnaireStore.definitions$);
  categorySig$ = toSignal(this.#questionnaireStore.category$);
  questionnaireIdSig$ = toSignal(this.#questionnaireStore.questionnaireId$);
  canUserEditQuestionnaire$ = toSignal(this.#questionnaireStore.canUserEditQuestionnaire$);
  #router = inject(Router);
  #globalService = inject(GlobalService);
  stepForm = new FormControl<Step>({ id: 0, questions: [] } as Step)
  #dragStore = inject(DragStore);
  #globalStore = inject(GlobalStore);
  #dialog = inject(MatDialog);
  #tostesStore = inject(TostesStore);
  #uuidService = inject(UuidService);
  #answersStore = inject(AnswersStore);
  backColor$ = this.#questionnaireStore.backColor$;
  currentIndex$ = toSignal(this.#questionnaireStore.currentStepIndex$)
  status$ = this.#questionnaireStore.status$;
  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);
  currentStepToEditSignal$ = toSignal(this.stepForm.valueChanges);
  recentlySave$ = this.#questionnaireStore.recentlySave;
  changeNotSavedInCurrentStep$ = toSignal(this.#questionnaireStore.changeNotSavedInCurrentStep$);
  unnecessaryChangesInCurrentStep$ = toSignal(this.#questionnaireStore.unnecessaryChangesInCurrentStep$);
  stepNames$ = toSignal(this.#questionnaireStore.stepNames$);
  addingStepNow$ = toSignal(this.#questionnaireStore.addingStepNow$);
  clickStartedInCenter$ = toSignal(this.#dragStore.clickStartedInCenter$);

  goToBottomEvent$ = inject(DragStore).goToBottomEvent$;
  goToTopEvent$ = inject(DragStore).goToTopEvent$;
  // goToBottomEventSig$ = toSignal(this.goToBottomEvent$);

  currentTab = 0;
  isOpenAddComponents = true;
  isOpenStepMenu = true;
  lastIndex?: number;
  indeactivate = false;
  addingNow = false;
  constructor(private readonly crd: ChangeDetectorRef) {

    this.status$.pipe(filter(st => st == EQuestionnaireStatus.Distributed || st == EQuestionnaireStatus.Respond)).subscribe(
      notValid => {
        this.#tostesStore.addTost({
          guid: this.#tostesStore.generateGuid(),
          message: { en: "Error! Questionnaire can't be edit. status not valid", he: "שגיאה! לא ניתן לערוך את השאלון. סטטוס לא חוקי" }
          , position: TostPositionEnum.BottomLeft, seconds: 5, type: TostTypeEnum.ERROR
        });
        this.#router.navigate(["main"]);
      }
    )
    this.lastIndex = this.currentIndex$();
    this.stepForm.valueChanges
      .pipe(tap(x => {
        if (this.unnecessaryChangesInCurrentStep$() ?? 0 > 0) {
          this.#questionnaireStore.addUnnecessaryChanges(false);
        }
        else {
          this.#questionnaireStore.updateWasChangeNotSave(true)
        }
      }))
      .pipe(debounceTime(3000))
      .subscribe(step => {
        if (this.changeNotSavedInCurrentStep$()) {
          if (step) {
            this.saveStep(step)
          }
        }
        this.#questionnaireStore.updateWasChangeNotSave(false)
      });
    this.#dragStore.indexToDuplicateStep$
      .pipe(filter(index => index != undefined))
      .subscribe((index) => {
        if (this.stepForm.value)
          this.#questionnaireStore.DuplicateStep({ currentStep: this.stepForm.value, index: index! });
        this.#dragStore.duplicateStep(undefined);
      }
      );

    this.#dragStore.indexToAddToCollection$
      .pipe(filter(index => index != undefined && this.stepForm.value?.questions[index!] != undefined))
      .subscribe((index) =>{
        this.#dialog.open(SaveNameListComponent,
          {
            autoFocus: false,
            data: { isCreateCollectionQuestionPopup: true, name: this.stepForm.value!.questions[index!]!.titleToData, isCreate: true },
          }
        ).afterClosed()
          .pipe(tap(x => {
            this.#dragStore.addToCollection(undefined);
            if (x) {
              var questionId = this.stepForm.value?.questions.find((q, i) => i == index)?.id;
              this.stepForm.setValue({
                ...this.stepForm.value, questions: this.stepForm.value?.questions.map((q, i) => {
                  if (q.id == questionId || q.parentFollowUpQuestionId == questionId)
                    return { ...q, collectionQuestionId: 11111 };
                  else return q;
                })
              } as Step)
            }
          }))
          .subscribe(resultFromPopUp => {
            if (resultFromPopUp) {
              var questionId = this.stepForm.value?.questions.find((q, i) => i == index)?.id;
              this.#globalStore
                .createCollectionQuestion({ ...this.stepForm.value!.questions[index!], titleToData: resultFromPopUp, followQuestions: [...this.stepForm.value!.questions.filter(q => q.parentFollowUpQuestionId == questionId)] })
            }
          })
  });

    this.#dragStore.addFollowUpQuestion$
      .pipe(filter(followUpDetails => followUpDetails != undefined))
      .subscribe((followUpDetails) => {
        this.#dragStore.addFollowUpQuestion(undefined)
        if (this.stepForm.value?.id && this.questionnaireIdSig$()) {
          this.addingNow = true;
          var question = { ...this.#globalService.getQuestionFromDefaulteArrByType(followUpDetails?.type.id ?? 0), followAnswerOptionItemGuid: followUpDetails?.optionItemGuid, parentFollowUpQuestionId: followUpDetails?.questionId, type: followUpDetails?.type } as Question;
          if (question) {
            this.#questionnaireApiService.createQuestionWithSaveStep(this.stepForm.value?.id, this.questionnaireIdSig$()!, this.stepForm.value?.questions.length, question, this.stepForm.value)
              .subscribe(idFromServer => {
                var status = this.stepForm.value?.status;
                if (status && status != EStatus.Created && status != EStatus.Deleted) {
                  status = EStatus.Changed
                }
                var index = 0;
                this.stepForm.setValue({
                  ...this.stepForm.value,
                  questions: [...this.stepForm.value?.questions.flatMap((q, i) => {
                    if (q.id == followUpDetails?.questionId) {
                      index = i + 1;
                      return [{
                        ...q,
                        optionsList: {
                          ...q.optionsList,
                          answerOptionItem: [...q.optionsList?.answerOptionItem?.map(a => { return followUpDetails.optionItemGuid == a.guid ? { ...a, followQuestionChildsIdes: [...a.followQuestionChildsIdes ?? [], idFromServer] } : a }) ?? []]
                        }
                      }, { ...question, id: idFromServer, modularQuestions: question!.modularQuestions?.map(m => { return { ...m, id: 0 } }), status: EStatus.Saved } as Question]
                      // collectionQuestionId: question!.id != 0 ?question!.id : null,
                    }
                    return [q];
                  }) ?? [],
                  ],
                  status
                } as Step, { emitEvent: true });
                this.#dragStore.updatFocusId(index);
                // this.#dragStore.goToBottom(true);
                this.addingNow = false;
              });
          }
        }
        else {
        }
      });


    this.#dragStore.doScreanImage$.subscribe((doScreanImg) => {
      if (doScreanImg) {
        this.captureScreen()
          .then(img => {
            if (img) {
              this.#questionnaireStore.saveTemplateImg(img);
              this.#dragStore.updateDoScreenImage(false);
            }
          })
          .catch(error => {
            console.error('Error capturing screen:', error);
          });
      }
    });

    this.#dragStore.indexToSaveList$
      .pipe(filter(index => index != undefined && this.stepForm.value?.questions[index!] != undefined))
      .subscribe((index) => {
        if (this.stepForm.value!.questions[index!].optionsList) {
          this.#dialog.open(SaveNameListComponent,
            {
              autoFocus: false,
            }
          ).afterClosed()
            .pipe(map(resultFromPopUp => {
              this.#dragStore.saveList(undefined);
              if (resultFromPopUp.name as string) {
                var newlist = {
                  ...this.stepForm.value!.questions[index!].optionsList,
                  guid: this.#uuidService.generateUUID(),
                  isPublic: true, name: resultFromPopUp.name,
                  answerOptionItem: this.stepForm.value!.questions[index!].optionsList?.answerOptionItem?.map(a => { return { ...a, guid: this.#uuidService.generateUUID() } })
                } as OptionsList;
                this.stepForm.setValue({
                  ...this.stepForm.value, questions: this.stepForm.value?.questions.map((q, i) => {
                    if (i == index)
                      return { ...q, optionsList: newlist };
                    else return q;
                  })
                } as Step)
                return newlist;
              }
              return null;
            }))
            .subscribe(newlist => {
              if (newlist) {
                this.#globalStore.createSavedList(newlist as OptionsList);
              }
            })
        }
      }
      );

    
  }
  ngOnInit(): void {
    this.goToBottomEvent$.subscribe(t => {
      if (t) {
        this.scrollToBottom();
        this.#dragStore.goToBottom(false);
      }
    });

    this.goToTopEvent$.subscribe(t => {
      if (t) {
        this.scrollToTop();
        this.#dragStore.goToTop(false);
      }
    });


    // כאשר מחליפים עמוד - מעדכן את הפורם לקבל את העמוד הנוכחי מהסטור
    this.#questionnaireStore.currentStepIndex$.pipe(
      withLatestFrom(this.#questionnaireStore.questionnaire$, this.#questionnaireStore.changeNotSavedInCurrentStep$, this.stepForm.valueChanges.pipe(startWith(null))))
      .subscribe(([currentStepIndex, questionnaire, wasChangeNotSave, currentStep]) => {
        this.#dragStore.resetFocusId();
        var newStep = questionnaire.steps[currentStepIndex];
        const updatedName = this.stepNames$()?.find(s => s.id == currentStep?.id)?.title;
        if (currentStep) {
          var currentStepCorrect = { ...currentStep, title: updatedName }
          if (wasChangeNotSave) {
            this.saveStepAsync(currentStepCorrect, this.lastIndex == 0);
          }
          else {
            this.#questionnaireStore.SaveStepLocal(currentStepCorrect)
          }
        }
        this.stepForm.setValue(newStep);
        this.#questionnaireStore.updateWasChangeNotSave(false);
        this.#questionnaireStore.resetUnnecessaryChanges();
        this.lastIndex = currentStepIndex;
      });
  }
  saveFromBtn() {
    if (this.stepForm.value) {
      this.saveStep(this.stepForm.value);
    }
  }
  saveStep(step: Step) {
    this.#questionnaireStore.SaveStep({ step: step, isToLogg: false, });
  }

  async saveStepAsync(step: Step, isFirst: boolean) {
    var img = undefined;
    if (isFirst) {
      img = await this.captureScreen();
    }
    this.#questionnaireStore.SaveStep({ step: step, isToLogg: true, imgScreen: img });
  }

  addTypeQuestionsToBoard(event: any) {
    var question = { id: 0, status: EStatus.Created, ...this.#globalService.getQuestionFromDefaulteArrByType(event?.id), type: event }
    this.addQuestion(question);
  }
  addQuestionFromCollection(question: Question) {
    this.addQuestion(question)
  }
  addQuestion(q: Question) {
    if (this.stepForm.value?.id && this.questionnaireIdSig$()) {
      this.addingNow = true;
      this.#questionnaireApiService.createQuestion(this.stepForm.value?.id, this.questionnaireIdSig$()!, this.stepForm.value?.questions.length, q)
        .subscribe(idFromServer => {
          var status = this.stepForm.value?.status;
          if (status && status != EStatus.Created && status != EStatus.Deleted) {
            status = EStatus.Changed
          }
          this.stepForm.setValue({
            ...this.stepForm.value,
            questions: [...this.stepForm.value?.questions ?? [],
            {
              ...q,
              collectionQuestionId: q.id != 0 ? q.id : null,
              id: idFromServer,
              modularQuestions: q.modularQuestions?.map(m => { return { ...m, id: 0 } }),
              status: EStatus.Saved
            }],
            status
          } as Step, { emitEvent: true });
          this.#dragStore.updatFocusId((this.stepForm.value?.questions.length ?? 0) - 1);
          this.#dragStore.goToBottom(true);
          this.addingNow = false;
          if (q.followQuestions?.length ?? 0 > 0) {
            q.followQuestions?.forEach(fq =>
              this.addQuestion({ ...fq, parentFollowUpQuestionId: idFromServer })
            )
          }
        });
    }
    else {
      console.error("error from create questionnaire page with ad qustion - because of the stepId or questionnaireId");
    }
  }

  changeTab(num: number) {
    this.currentTab = num;
    this.isOpenAddComponents = true;
  }

  async captureScreen() {
    this.#dragStore.resetFocusId();
    this.crd.detectChanges();
    if (this.warpBoard) {
      const outerElement = this.warpBoard.nativeElement;
      const innerElement = outerElement.querySelector('.board-edit'); // Replace with the actual class or selector of the inner element

      // Save the original styles and scroll position
      if (innerElement) {
        const outerOriginalStyle = {
          height: outerElement.style.height,
          overflow: outerElement.style.overflow,
        };

        const innerOriginalStyle = {
          height: innerElement.style.height,
          overflow: innerElement.style.overflow,
        };

        // Set a fixed height and overflow: hidden to hide the scrollbar
        outerElement.style.height = '1000px'; // Adjust the height as needed
        outerElement.style.overflow = 'hidden';

        innerElement.style.height = 'auto';
        innerElement.style.overflow = 'hidden';

        try {
          // Scroll to the top to capture the entire content
          outerElement.scrollTop = 0;

          // Capture the image
          const dataUrl: string = await domToImage.toPng(outerElement);

          return dataUrl;
        } finally {
          // Restore the original styles and scroll position
          outerElement.style.height = outerOriginalStyle.height;
          outerElement.style.overflow = outerOriginalStyle.overflow;

          innerElement.style.height = innerOriginalStyle.height;
          innerElement.style.overflow = innerOriginalStyle.overflow;
        }
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }
  updateAddingNow(bool: boolean) {
    this.addingNow = bool;
  }
  saveQuestionnarie() {
    if (!this.indeactivate) {
      this.indeactivate = true;
      if (this.canUserEditQuestionnaire$() && this.changeNotSavedInCurrentStep$()) {
        this.#questionnaireStore.updateWasChangeNotSave(false);
        this.#questionnaireStore.resetUnnecessaryChanges();
        var guid = this.#tostesStore.generateGuid();
        this.#tostesStore.addTost({ guid, message: { en: "save...", he: "שומר..." }, type: TostTypeEnum.LOAD });
        this.#questionnarieGridStore.updateDefinitions({
          id: this.questionnaireIdSig$() ?? 0,
          definitions: this.definitionsSig$(),
          category: this.categorySig$(),
        });
        if (this.stepForm.value) {
          this.#questionnaireStore.SaveStepLocal(this.stepForm.value);
          this.#questionnaireApiService.saveStep(this.questionnaireIdSig$() ?? 0, this.stepForm.value!, false, '', guid);
        }
        this.#questionnaireApiService.saveDefinitions(
          { definitions: this.definitionsSig$(), category: this.categorySig$() },
          this.questionnaireIdSig$() ?? 0
        );
      }
    }
  }
  cancelFocus() {
    if (!this.clickStartedInCenter$()) {
      this.#dragStore.resetFocusId();
    }
    this.#dragStore.onCenterMouseDown(false);
  }
  changeStatusComponentMenu() {
    this.isOpenAddComponents = !this.isOpenAddComponents;
  }
  changeStatusStepMenu() {
    this.isOpenStepMenu = !this.isOpenStepMenu;
  }
  addStep() {
    this.#questionnaireStore.AddStep();
  }
  scrollToBottom() {
    setTimeout(() => {
      if (this.warpBoard) {
        this.warpBoard.nativeElement.scrollTop = this.warpBoard.nativeElement.scrollHeight;
      }
    });
  }
  scrollToTop() {
    setTimeout(() => {
      if (this.warpBoard) {
        this.warpBoard.nativeElement.scrollTop = 0;
      }
    }
    );
  }
}